import { Star, ExternalLink } from "lucide-react";
import { REVIEWS, COMPANY } from "../data/site";

/* eslint-disable react/no-unescaped-entities */

export default function Reviews() {
  return (
    <section data-testid="reviews-section" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <div className="text-xs uppercase tracking-[0.22em] font-bold text-red-600">
              Real Austin homeowners
            </div>
            <h2 className="mt-3 font-display text-4xl sm:text-5xl font-black tracking-tighter text-stone-900 leading-[1.02]">
              Trusted, reviewed, recommended.
            </h2>
          </div>
          <a
            href={COMPANY.gmb}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="reviews-gmb-link"
            className="inline-flex items-center gap-2 text-sm font-bold text-stone-900 hover:text-red-600 border-b-2 border-stone-900 hover:border-red-600 pb-1 self-start"
          >
            See all reviews on Google <ExternalLink size={14} />
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {REVIEWS.map((r, i) => (
            <article
              key={r.name}
              className="border border-stone-200 p-7 md:p-9 bg-stone-50/40"
              data-testid={`review-${i}`}
            >
              <div className="flex items-center gap-1 text-yellow-500">
                {Array.from({ length: r.rating }).map((_, idx) => (
                  <Star key={idx} size={16} fill="#eab308" stroke="#eab308" />
                ))}
              </div>
              <blockquote className="mt-5 text-stone-800 leading-relaxed text-lg">"{r.quote}"</blockquote>
              <footer className="mt-6 flex items-center justify-between text-sm">
                <cite className="not-italic font-bold text-stone-900">{r.name}</cite>
                <span className="text-stone-500">{r.area}</span>
              </footer>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
